document.body.addEventListener('click', e => {
    const button = e.target.closest('[data-has-many-add]');
    if (button) {

        button.blur();

        function replaceAttributeText(element, searchValue, replaceValue) {
            if (element.nodeType === Node.ELEMENT_NODE) {
                for (const attribute of element.attributes) {
                    attribute.value = attribute.value.replace(searchValue, replaceValue);
                }
                for (const child of element.childNodes) {
                    replaceAttributeText(child, searchValue, replaceValue);
                }
            }
        }


        const wrapper = button.closest('[data-has-many]');
        const index = Number(wrapper.dataset.hasMany ?? 0);
        wrapper.dataset.hasMany = index + 1;

        const template = wrapper.querySelector('template');
        const item = template.content.firstElementChild.cloneNode(true);


        replaceAttributeText(item, '__NEW__', index);

        template.parentElement.insertBefore(item, template);

    }
});
